/* eslint-disable unicorn/no-useless-undefined */
/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable jsx-a11y/anchor-is-valid */
import { Container, Stack, Typography } from "@mui/material";
import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";

import SEO from "../components/common/seo";
import { persistor } from "../store";
import {
  setNewProfile,
  setNewProfileAvatar,
  setNewProfileRole,
} from "../store/newProfile/slice";
import { loginStyle } from "../styles/container/login";
import { logoutMicrosoftRedirect } from "../utils/new-azure-ad";
import { getIsBypassLogin } from "../utils/token";

export function Logout() {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  useEffect(() => {
    const isBypassLogin = getIsBypassLogin();

    const performLogout = async () => {
      await persistor.purge();
      sessionStorage.clear();
      localStorage.clear();

      dispatch(setNewProfile(undefined));
      dispatch(setNewProfileRole(undefined));
      dispatch(setNewProfileAvatar(undefined));

      if (isBypassLogin) {
        navigate("/login", { replace: true });
      } else {
        await logoutMicrosoftRedirect();
      }
    };

    performLogout();
  }, []);

  return (
    <>
      <SEO />
      <Container maxWidth={false} disableGutters>
        <Stack
          component="section"
          direction="row"
          alignItems="center"
          justifyContent="center"
          sx={{
            ...loginStyle.contentStack,
            height: { xs: "500px", sm: "520px" },
            flexDirection: "column",
            gap: 0,
          }}
        >
          <Typography
            sx={{
              textAlign: "center",
              fontWeight: "700",
              fontSize: "24px",
              color: "white",
              marginBottom: "4px",
            }}
          >
            Logout is in progress.
          </Typography>
          <Typography
            sx={{
              textAlign: "center",
              color: "white",
              fontSize: "18px",
              maxWidth: "80%",
            }}
          >
            We will immediately redirect you to the login page...
          </Typography>
        </Stack>
      </Container>
    </>
  );
}
